import { Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { ApiService, Resp } from '@app/core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private readonly _url = `${portalConst.api.suporte}/v1`;

  constructor(private _api: ApiService) {}

  public getProducts(paisId?: number): Observable<Resp<any>> {
    return this._api.get(`${this._url}/products`, { pais_id: paisId });
  }

  public postFeedback(data: any, paisId?: number): Observable<Resp<any>> {
    return this._api.post(`${this._url}/feedbacks`, { ...data, pais_id: paisId });
  }
}
